// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__e1E+N","AddNew":"styles_AddNew__yYaAL","CommentButton":"styles_CommentButton__ciQIK","CommentButton__text":"styles_CommentButton__text__j6xsy"};